import React from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import {Link} from 'gatsby';
import {InputText, InputCheckbox, InputLocation} from '@evag/ec-react';
import '@evag/ec-react/dist/main.css';

import colors from 'src/components/colors';
import Button from 'src/components/Button';
import s from './Basic.module.scss';
import is from './inputs.module.scss';

const subscribeText = 'Quero receber novidades da Sâmia.';
const defaultBtnText = 'Assinar';

const Peticao = ({
  title,
  text,
  values,
  onChange,
  onBlur,
  showFiliado,
  setFieldValue,
  btnText = defaultBtnText,
}) => {
  const props = (name) => ({name, value: values[name], onChange, onBlur});
  return (
    <div className={s.sidebar}>
      <p className={s.title}>{title}</p>
      <p className={s.text}>{text}</p>
      <InputText
        className={is.text}
        placeholder="Nome completo"
        {...props('name')}
      />
      <InputText
        className={is.text}
        placeholder="E-mail"
        type="email"
        {...props('email')}
      />
      <InputText
        className={is.text}
        cleave={{
          blocks: [0, 2, 9],
          delimiters: ['(', ') '],
          numericOnly: true,
        }}
        placeholder="WhatsApp (opcional)"
        type="tel"
        {...props('phone')}
      />
      <InputLocation
        className={is.select}
        names={['uf', 'city']}
        firstUf="SP"
        {...{values, onChange, onBlur, setFieldValue}}
      />

      {showFiliado ? <InputCheckbox
        className={is.checkbox + ' ' + s.checkbox}
        label="Sou filiada(o) ao PSOL"
        {...props('filiado')}
      /> : null}

      <InputCheckbox
        className={is.checkbox + ' ' + s.checkbox}
        label={subscribeText}
        {...props('subscribe')}
      />

      <input type="hidden" name="redirect" value={values.redirect} />
      <Button
        bg={colors.white}
        fg={colors.red}
        fontSize="16px"
        type="submit"
        width="100%"
      >
        {btnText}
      </Button>
      <p className={s.privacy}>
        <Link to="/politica-de-privacidade">Política de privacidade</Link>
      </p>
    </div>
  );
};

Peticao.propTypes = {
  title: PropTypes.string,
  btnText: PropTypes.string,
  text: PropTypes.string,
  values: PropTypes.object.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

Peticao.initialValues = {
  name: '',
  email: '',
  phone: '',
  uf: '',
  city: '',
  filiado: false,
  subscribe: false,
  redirect: 'https://samiabomfim.com.br/ok/',
};

Peticao.validationSchema = Yup.object().shape({
  name: Yup.string().required('O campo Nome é obrigatório.'),
  email: Yup.string()
    .email('Digite um e-mail válido.')
    .required('O campo E-mail é obrigatório.'),
  phone: Yup.string(),
  uf: Yup.string().required('O campo Estado é obrigatório.'),
  city: Yup.string().required('O campo Cidade é obrigatório.'),
  subscribe: Yup.bool(),
  filiado: Yup.bool(),
});

Peticao.captcha = true;
Peticao.element = Peticao;
export default Peticao;
